import React, { useEffect, useState } from 'react';
import FormView from './FormView';
import { useForm } from 'react-hook-form';
import { useDropDownMutation } from '../../../apis/useDropDownMutation';
import { BUSINESS_INFORMATION_FIELDS } from '../../../utils/shortFormConfig';
import { handleUpload } from '../../../utils/FileToBase64';
import {
    useApiAuthMutationDynamic,
    useApiMutation2
} from '../../../apis/useApi';
import { toast } from 'react-toastify';
import { getDecodedQueryParam } from '../../../utils/commanUtil';

const FormContainer = () => {
    const queryParams: any = getDecodedQueryParam();
    const [dropdownOptions, setDropdownOptions] = React.useState<any>({});

    const [corporatePresentations, setCorporatePresentations] = useState<
        File[]
    >([]);

    const fileHandling = {
        corporatePresentation: {
            selectedFiles: corporatePresentations,
            setSelectedFiles: setCorporatePresentations
        }
    };

    interface FormData {
        requestorIndustryVertical?: string;
        shortFormSupportAndService?: string | string[];
        whereYourCompanyHearAboutBIDProgram?: string;
        [key: string]: any;
    }

    const formMethods = useForm<FormData>({
        mode: 'onChange',
        defaultValues: {
            whereYourCompanyHearAboutBIDProgram:
                'attendedADubaiChambersEventInDubai'
        }
    });

    const industryVertical = formMethods.watch('requestorIndustryVertical');
    const shortFormSupportAndService = formMethods.watch(
        'shortFormSupportAndService'
    );

    const getCountryList = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_COUNTRY`
    );
    const getIndustryVertical = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_INDUSTRY_VERTICAL`
    );

    const getNumberOfEmployees = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_NUMBER_OF_EMPLOYEES`
    );
    const getAnnualRevenue = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_ANNUAL_REVENUE`
    );
    const getCompanyCurrentFundingStage = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_COMPANY_CURRENT_FUNDING_STAGE`
    );
    const getShortFormSupportAndService = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_SHORT_FORM_SUPPORT_SERVICE`
    );
    const getUAENationalConfirmation = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_UAE_NATIONAL_CONFIRMATION`
    );
    const getBIDProgram = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_PROGRAM_REFERENCE`
    );


    const createMatchmakingRequestWithToken = useApiAuthMutationDynamic<
        any,
        {}
    >(`/o/c/matchmakingrequestors/scopes/BID Partner`, 'post', {
        onSuccess: () => {
            toast.success('Form Submitted Successfully', {
                theme: 'light',
                autoClose: 2000
            });
            formMethods.reset();
            setCorporatePresentations([]);
        },
        onError: (error: any) => {
            if (error?.response?.status === 400) {
                toast.error(error?.response?.data?.title, {
                    theme: 'light',
                    autoClose: 2000
                });
            }
        }
    });

    useEffect(() => {
        const updateDropdownOptions = async () => {
            setDropdownOptions((prevData: any) => ({
                ...prevData,
                requestorCountryOrOrigin: getCountryList,
                requestorCompanyCurrentFundingStage:
                    getCompanyCurrentFundingStage,
                requestorAnnualRevenue: getAnnualRevenue,
                numberOfEmployees: getNumberOfEmployees,
                requestorIndustryVertical: getIndustryVertical,
                requestorOutsideHeadquarterCountires: getCountryList,
                shortFormSupportAndService: getShortFormSupportAndService,
                businessOwnedOrCofoundedByUAE: getUAENationalConfirmation,
                whereYourCompanyHearAboutBIDProgram: getBIDProgram
            }));
        };
        updateDropdownOptions();
    }, [
        getCountryList,
        getIndustryVertical,
        getNumberOfEmployees,
        getAnnualRevenue,
        getCompanyCurrentFundingStage,
        getShortFormSupportAndService,
        getUAENationalConfirmation,
        getBIDProgram
    ]);

      useEffect(() => {
          if (queryParams?.eventId) {
              formMethods.setValue(
                  'whereYourCompanyHearAboutBIDProgram',
                  'attendedADubaiChambersEventInDubai'
              );
          }
      }, [queryParams?.eventId]);

    const businessInformationFields = BUSINESS_INFORMATION_FIELDS.filter(
        (field) => {
            if (field?.name === 'otherIndustryVertical')
                return industryVertical === 'others';
            else if (field?.name === 'otherShortFormSupportAndService') {
                return shortFormSupportAndService?.includes('other');
            }
            return true;
        }
    );

     const getToken = useApiMutation2<
         { access_token: string },
         { grant_type: string; client_id: string; client_secret: string }
     >('o/oauth2/token', 'post');

    const handleSubmit = async (data: any) => {
        const { corporatePresentation, ...payload } = data;

        const corporatePresentationFiles = corporatePresentations || [];
        let allAttachments: any[] = [];
        if (corporatePresentations?.length) {
            await handleUpload(
                corporatePresentationFiles,
                allAttachments
            );
        }

        const updatedPayload = {
            ...payload,
            eventId: Number(queryParams?.eventId) || null,
            requestorFirstName: data?.contactFirstName?.trim(),
            requestorLastName: data?.contactLastName?.trim(),
            requestorWorkEmail: data?.contactWorkEmail?.trim(),
            requestorArrivalReference: { name: 'By EPD', key: 'byEPD' },
            matchmakingToAttachment: allAttachments
        };

        const tokenResponse = await getToken.mutateAsync({
            data: {
                grant_type: 'client_credentials',
                client_id: 'id-e18bb565-c75a-2b97-9b72-45182297b8bf',
                client_secret: 'secret-38c64dc5-99cf-2d36-a59b-1bee3688b78'
            }
        });

        if (!tokenResponse?.access_token) {
            toast.error('Failed to get access token', {
                theme: 'light',
                autoClose: 2000
            });

            throw new Error('Failed to get access token');
        }

        await createMatchmakingRequestWithToken.mutateAsync({
            data: updatedPayload,
            token: tokenResponse.access_token
        });
    };

    return (
        <FormView
            onSubmit={handleSubmit}
            formMethods={formMethods}
            isSubmitting={
                createMatchmakingRequestWithToken?.isLoading ||
                getToken?.isLoading
            }
            dropdownOptions={dropdownOptions}
            businessInformationFields={businessInformationFields}
            fileHandling={fileHandling}
        />
    );
};

export default FormContainer;
